<form [formGroup]="sectorService.sectorForm">
	<div class="sector-section">
		<span class="section-head">Sector Information</span>

		<div class="segment-row mb-3">
			<div class="segment-col">
				<input *ngIf="!manualEntryChecked" oninput="this.value = this.value.toUpperCase()" class="main-input input-ui w-100" type="text" disabled placeholder="___/___/___/___/___" formControlName="txtSector1"
					autocomplete="off" (keyup)="sectorService.getSector1($event)" (change)="sectorService.bindSector1($event.target.value)" 
					maxlength="19" />
					<input *ngIf="manualEntryChecked" tabIndex="{{isTenantIndian ? 17 : 19}}" oninput="this.value = this.value.toUpperCase()" class="main-input" type="text"
				[ngClass]="{'validateError': (sectorService.sectorForm.controls.txtSector1.invalid && sectorService.sectorForm.controls.txtSector1.touched) || 
					(!sectorService.sectorForm.controls.txtSector1.valid && sectorService.submitted)}"
					placeholder="___/___/___/___/___" formControlName="txtSector1" autocomplete="off"
					(keyup)="sectorService.getSector1($event)" (change)="sectorService.bindSector1($event.target.value,false)"
					maxlength="31" />
				<label>Sector 1</label>
			</div>

			<div class="segment-col ml-3">
				<input *ngIf="!manualEntryChecked" oninput="this.value = this.value.toUpperCase()" formControlName="txtSector2" class="main-input input-ui w-100" type="text" disabled placeholder="___/___/___/___/___" />
				<input *ngIf="manualEntryChecked" tabIndex="{{isTenantIndian ? 18 : 20}}"  oninput="this.value = this.value.toUpperCase()" class="main-input" type="text"
					placeholder="___/___/___/___/___" formControlName="txtSector2" autocomplete="off"
					(keyup)="sectorService.getSector2($event)" (change)="sectorService.bindSector2($event.target.value)"
					maxlength="19" />
				<label>Sector 2</label>
			</div>
		</div>

	</div>

	<div class="sector-generated">
		<table class="table table-hovered table-bordered">
			<thead>
				<tr>
					<th>Sector</th>
					<th>Airline PNR</th>
					<th>AL/PF</th>
					<th>FLT NO.</th>
					<th>CL</th>
					<th>DEP. DATE TIME</th>
					<th>ARR. DATE TIME</th>
					<th>DEP. Airport</th>
					<th>Arr. Airport</th>
					<th>Baggage</th>
				</tr>
			</thead>

			<tbody>
				<ng-container formArrayName="sectorlist"
					*ngFor="let sectorlist of sectorService.DynamicFormControls.controls; let i = index ">
					<tr [formGroupName]="i">
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtSectorComb}}
						</td>
						<td *ngIf="manualEntryChecked"><input oninput="this.value = this.value.toUpperCase()" 
							type="text" disabled formControlName="txtSectorComb" maxlength="7" />
					</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtAirlinePnrX}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+1+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+1+(isTenantIndian ? 18 : 20)}}" maxlength="12"
								oninput="this.value = this.value.toUpperCase()" 
								type="text" formControlName="txtAirlinePnrX" (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sectorlist.controls.txtAirlinePnrX.invalid && sectorlist.controls.txtAirlinePnrX.touched) || 
					            (!sectorlist.controls.txtAirlinePnrX.valid && sectorService.submitted)}" />
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtAirlinePrefix}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+2+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+2+(isTenantIndian ? 18 : 20)}}" maxlength="5"
								oninput="this.value = this.value.toUpperCase()" 
								type="text"  formControlName="txtAirlinePrefix"  (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sectorlist.controls.txtAirlinePrefix.invalid && sectorlist.controls.txtAirlinePrefix.touched) || 
					            (!sectorlist.controls.txtAirlinePrefix.valid && sectorService.submitted)}"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtFlightNo}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+3+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+3+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtFlightNo" (change)="sectorService.setNarration()" maxlength="6"
								[ngClass]="{'validateError': (sectorlist.controls.txtFlightNo.invalid && sectorlist.controls.txtFlightNo.touched) || 
					            (!sectorlist.controls.txtFlightNo.valid && sectorService.submitted)}"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtClass}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+4+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+4+(isTenantIndian ? 18 : 20)}}" maxlength="4"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtClass" (change)="sectorService.setNarration()"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.dateAirlineDepartInfo=='Invalid date'?'':sectorlist.value.dateAirlineDepartInfo | date : 'dd/MM/yyyy HH:mm' }}
						</td>
						<td *ngIf="dateTimeMultiTab=='false' && manualEntryChecked">
							<!-- DATE TIME FIELD -->
							<ng-container *ngIf="isLocaleDateFormat">
								<input tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" 
								class="unstyled w-75 traveller-input-field" type="datetime-local"
								formControlName="dateAirlineDepartInfo" (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sectorlist.controls.dateAirlineDepartInfo.invalid && sectorlist.controls.dateAirlineDepartInfo.touched) || 
								(!sectorlist.controls.dateAirlineDepartInfo.valid && sectorService.submitted)}"/>
							</ng-container>
							<ng-container *ngIf="!isLocaleDateFormat">
								<app-date-time-input
								formControlName="dateAirlineDepartInfo"
								(change)="sectorService.setNarration($event)"
								[dateFormat]="dateTimeFormat"
								[fieldController]="sectorlist.controls.dateAirlineDepartInfo"
								class="new-date-input"
								classes="unstyled traveller-input-field" 
								tIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}"
								[dynamicClasses]="{'validateError': (sectorlist.controls.dateAirlineDepartInfo.invalid && sectorlist.controls.dateAirlineDepartInfo.touched) || 
								(!sectorlist.controls.dateAirlineDepartInfo.valid && sectorService.submitted)}" 
								></app-date-time-input>
							</ng-container>
						</td>
						
						<td *ngIf="dateTimeMultiTab=='true' && manualEntryChecked" >
							<span style="display: flex;flex-flow: row;">
								<!-- DATE FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" 
									class=" traveller-input-field" type="date"
									formControlName="AirlineDepartDate" (change)="sectorService.setNarration()"
									[ngClass]="{'validateError': (sectorlist.controls.AirlineDepartDate.invalid && sectorlist.controls.AirlineDepartDate.touched) || 
									(!sectorlist.controls.AirlineDepartDate.valid && sectorService.submitted)}"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineDepartDate"
									(change)="sectorService.setNarration($event)"
									[dateFormat]="dateFormat"
									[fieldController]="sectorlist.controls.AirlineDepartDate"
									class="new-date-input"
									classes="traveller-input-field" 
									tIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}"
									[dynamicClasses]="{'validateError': (sectorlist.controls.AirlineDepartDate.invalid && sectorlist.controls.AirlineDepartDate.touched) || 
									(!sectorlist.controls.AirlineDepartDate.valid && sectorService.submitted)}" 
									></app-date-time-input>
								</ng-container>

								<!-- TIME FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input class=" traveller-input-field" type="time" formControlName="AirlineDepartTime"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineDepartTime"
									[dateFormat]="timeFormat"
									[fieldController]="sectorlist.controls.AirlineDepartTime"
									class="new-date-input"
									classes="traveller-input-field" 
									></app-date-time-input>
								</ng-container>

								
							</span>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.dateAirlineArrivalInfo=='Invalid date'?'':sectorlist.value.dateAirlineArrivalInfo  | date : 'dd/MM/yyyy HH:mm' }}
						</td>
						
						<td *ngIf="dateTimeMultiTab=='false' && manualEntryChecked">
							<!-- DATE TIME FIELD -->
						<ng-container *ngIf="isLocaleDateFormat">
							<input tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
							class="traveller-input-field" type="datetime-local"
							formControlName="dateAirlineArrivalInfo" (change)="sectorService.setNarration()"
							[ngClass]="{'validateError': (sectorlist.controls.dateAirlineArrivalInfo.invalid && sectorlist.controls.dateAirlineArrivalInfo.touched) || 
							(!sectorlist.controls.dateAirlineArrivalInfo.valid && sectorService.submitted)}"/>
						</ng-container>
						<ng-container *ngIf="!isLocaleDateFormat">
							<app-date-time-input
							formControlName="dateAirlineArrivalInfo"
							(change)="sectorService.setNarration($event)"
							[dateFormat]="dateTimeFormat"
							[fieldController]="sectorlist.controls.dateAirlineArrivalInfo"
							class="new-date-input"
							classes="unstyled traveller-input-field" 
							tIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
							[dynamicClasses]="{'validateError': (sectorlist.controls.dateAirlineArrivalInfo.invalid && sectorlist.controls.dateAirlineArrivalInfo.touched) || 
							(!sectorlist.controls.dateAirlineArrivalInfo.valid && sectorService.submitted)}" 
							></app-date-time-input>
						</ng-container>
					</td>
						
						<td *ngIf="dateTimeMultiTab=='true' && manualEntryChecked" >
							<span style="display: flex;flex-flow: row;">

								
								<!-- DATE FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
									class="traveller-input-field" type="date"
									formControlName="AirlineArrivalDate" (change)="sectorService.setNarration()"
									[ngClass]="{'validateError': (sectorlist.controls.AirlineArrivalDate.invalid && sectorlist.controls.AirlineArrivalDate.touched) || 
									(!sectorlist.controls.AirlineArrivalDate.valid && sectorService.submitted)}"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineArrivalDate"
									(change)="sectorService.setNarration($event)"
									[dateFormat]="dateFormat"
									[fieldController]="sectorlist.controls.AirlineArrivalDate"
									class="new-date-input"
									classes="traveller-input-field" 
									tIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
									[dynamicClasses]="{'validateError': (sectorlist.controls.AirlineArrivalDate.invalid && sectorlist.controls.AirlineArrivalDate.touched) || 
									(!sectorlist.controls.AirlineArrivalDate.valid && sectorService.submitted)}" 
									></app-date-time-input>
								</ng-container>

								<!-- TIME FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input class=" traveller-input-field" type="time" formControlName="AirlineArrivalTime"/> 
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineArrivalTime"
									[dateFormat]="timeFormat"
									[fieldController]="sectorlist.controls.AirlineArrivalTime"
									class="new-date-input"
									classes="traveller-input-field" 
									></app-date-time-input>
								</ng-container> 
							</span>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.departureCity}}, {{sectorlist.value.departureCityCode}}
						</td>
						<td *ngIf="manualEntryChecked" style="min-width: 150px;">
							<input tabIndex="{{i*11+7+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+7+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtAirlineDepartInfo" (change)="sectorService.setNarration()"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.arrivalCity}}, {{sectorlist.value.arrivalCityCode}}
						</td>
						<td *ngIf="manualEntryChecked"  style="min-width: 150px;">
							<input tabIndex="{{i*11+9+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+9+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtAirlineArrivalInfo" />
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorlist.value.txtBaggage}}
						</td>
						<td *ngIf="manualEntryChecked">

							<input tabIndex="{{i*11+11+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+11+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtBaggage" />
						</td>
					</tr>
				</ng-container>
				<ng-container formArrayName="sector2list"
					*ngFor="let sector2list of sectorService.DynamicFormControls2.controls; let i = index ">
					<tr [formGroupName]="i">
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtSectorComb2}}
						</td>
						<td *ngIf="manualEntryChecked"><input oninput="this.value = this.value.toUpperCase()" 
							type="text" disabled formControlName="txtSectorComb2" maxlength="7" />
					</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtAirlinePnrX}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+1+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+1+(isTenantIndian ? 18 : 20)}}" maxlength="12"
								oninput="this.value = this.value.toUpperCase()" 
								type="text" formControlName="txtAirlinePnrX" (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sector2list.controls.txtAirlinePnrX.invalid && sector2list.controls.txtAirlinePnrX.touched) || 
					            (!sector2list.controls.txtAirlinePnrX.valid && sectorService.submitted)}" />
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtAirlinePrefix2}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+2+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+2+(isTenantIndian ? 18 : 20)}}" maxlength="5"
								oninput="this.value = this.value.toUpperCase()" 
								type="text"  formControlName="txtAirlinePrefix2"  (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sector2list.controls.txtAirlinePrefix2.invalid && sector2list.controls.txtAirlinePrefix2.touched) || 
					            (!sector2list.controls.txtAirlinePrefix2.valid && sectorService.submitted)}"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtFlightNo2}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+3+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+3+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtFlightNo2" (change)="sectorService.setNarration()" maxlength="6"
								[ngClass]="{'validateError': (sector2list.controls.txtFlightNo2.invalid && sector2list.controls.txtFlightNo2.touched) || 
					            (!sector2list.controls.txtFlightNo2.valid && sectorService.submitted)}"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtClass2}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input tabIndex="{{i*11+4+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+4+(isTenantIndian ? 18 : 20)}}" maxlength="4"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtClass2" (change)="sectorService.setNarration()"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.dateAirlineDepartInfo2=='Invalid date'?'':sector2list.value.dateAirlineDepartInfo2 | date : 'dd/MM/yyyy HH:mm' }}
						</td>
						<td *ngIf="dateTimeMultiTab=='false' && manualEntryChecked">
							<!-- DATE TIME FIELD -->
							<ng-container *ngIf="isLocaleDateFormat">
								<input tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" 
								class="unstyled w-75 traveller-input-field" type="datetime-local"
								formControlName="dateAirlineDepartInfo2" (change)="sectorService.setNarration()"
								[ngClass]="{'validateError': (sector2list.controls.dateAirlineDepartInfo2.invalid && sector2list.controls.dateAirlineDepartInfo2.touched) || 
								(!sector2list.controls.dateAirlineDepartInfo2.valid && sectorService.submitted)}"/>
							</ng-container>
							<ng-container *ngIf="!isLocaleDateFormat">
								<app-date-time-input
								formControlName="dateAirlineDepartInfo2"
								(change)="sectorService.setNarration($event)"
								[dateFormat]="dateTimeFormat"
								[fieldController]="sector2list.controls.dateAirlineDepartInfo2"
								class="new-date-input"
								classes="unstyled traveller-input-field" 
								tIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}"
								[dynamicClasses]="{'validateError': (sector2list.controls.dateAirlineDepartInfo2.invalid && sector2list.controls.dateAirlineDepartInfo2.touched) || 
								(!sector2list.controls.dateAirlineDepartInfo2.valid && sectorService.submitted)}" 
								></app-date-time-input>
							</ng-container>
						</td>
						
						<td *ngIf="dateTimeMultiTab=='true' && manualEntryChecked" >
							<span style="display: flex;flex-flow: row;">
								<!-- DATE FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}" 
									class=" traveller-input-field" type="date"
									formControlName="AirlineDepartDate2" (change)="sectorService.setNarration()"
									[ngClass]="{'validateError': (sector2list.controls.AirlineDepartDate2.invalid && sector2list.controls.AirlineDepartDate2.touched) || 
									(!sector2list.controls.AirlineDepartDate2.valid && sectorService.submitted)}"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineDepartDate2"
									(change)="sectorService.setNarration($event)"
									[dateFormat]="dateFormat"
									[fieldController]="sector2list.controls.AirlineDepartDate2"
									class="new-date-input"
									classes="traveller-input-field" 
									tIndex="{{i*11+5+(isTenantIndian ? 18 : 20)}}"
									[dynamicClasses]="{'validateError': (sector2list.controls.AirlineDepartDate2.invalid && sector2list.controls.AirlineDepartDate2.touched) || 
									(!sector2list.controls.AirlineDepartDate2.valid && sectorService.submitted)}" 
									></app-date-time-input>
								</ng-container>

								<!-- TIME FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input class=" traveller-input-field" type="time" formControlName="AirlineDepartTime2"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineDepartTime2"
									[dateFormat]="timeFormat"
									[fieldController]="sector2list.controls.AirlineDepartTime2"
									class="new-date-input"
									classes="traveller-input-field" 
									></app-date-time-input>
								</ng-container>

								
							</span>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.dateAirlineArrivalInfo2=='Invalid date'?'':sector2list.value.dateAirlineArrivalInfo2  | date : 'dd/MM/yyyy HH:mm' }}
						</td>
						
						<td *ngIf="dateTimeMultiTab=='false' && manualEntryChecked">
							<!-- DATE TIME FIELD -->
						<ng-container *ngIf="isLocaleDateFormat">
							<input tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
							class="traveller-input-field" type="datetime-local"
							formControlName="dateAirlineArrivalInfo2" (change)="sectorService.setNarration()"
							[ngClass]="{'validateError': (sector2list.controls.dateAirlineArrivalInfo2.invalid && sector2list.controls.dateAirlineArrivalInfo2.touched) || 
							(!sector2list.controls.dateAirlineArrivalInfo2.valid && sectorService.submitted)}"/>
						</ng-container>
						<ng-container *ngIf="!isLocaleDateFormat">
							<app-date-time-input
							formControlName="dateAirlineArrivalInfo2"
							(change)="sectorService.setNarration($event)"
							[dateFormat]="dateTimeFormat"
							[fieldController]="sector2list.controls.dateAirlineArrivalInfo2"
							class="new-date-input"
							classes="unstyled traveller-input-field" 
							tIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
							[dynamicClasses]="{'validateError': (sector2list.controls.dateAirlineArrivalInfo2.invalid && sector2list.controls.dateAirlineArrivalInfo2.touched) || 
							(!sector2list.controls.dateAirlineArrivalInfo2.valid && sectorService.submitted)}" 
							></app-date-time-input>
						</ng-container>
					</td>
						
						<td *ngIf="dateTimeMultiTab=='true' && manualEntryChecked" >
							<span style="display: flex;flex-flow: row;">

								
								<!-- DATE FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
									class="traveller-input-field" type="date"
									formControlName="AirlineArrivalDate2" (change)="sectorService.setNarration()"
									[ngClass]="{'validateError': (sector2list.controls.AirlineArrivalDate2.invalid && sector2list.controls.AirlineArrivalDate2.touched) || 
									(!sector2list.controls.AirlineArrivalDate2.valid && sectorService.submitted)}"/>
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineArrivalDate2"
									(change)="sectorService.setNarration($event)"
									[dateFormat]="dateFormat"
									[fieldController]="sector2list.controls.AirlineArrivalDate2"
									class="new-date-input"
									classes="traveller-input-field" 
									tIndex="{{i*11+6+(isTenantIndian ? 18 : 20)}}"
									[dynamicClasses]="{'validateError': (sector2list.controls.AirlineArrivalDate2.invalid && sector2list.controls.AirlineArrivalDate2.touched) || 
									(!sector2list.controls.AirlineArrivalDate2.valid && sectorService.submitted)}" 
									></app-date-time-input>
								</ng-container>

								<!-- TIME FIELD -->
								<ng-container *ngIf="isLocaleDateFormat">
									<input class=" traveller-input-field" type="time" formControlName="AirlineArrivalTime2"/> 
								</ng-container>
								<ng-container *ngIf="!isLocaleDateFormat">
									<app-date-time-input
									formControlName="AirlineArrivalTime2"
									[dateFormat]="timeFormat"
									[fieldController]="sector2list.controls.AirlineArrivalTime2"
									class="new-date-input"
									classes="traveller-input-field" 
									></app-date-time-input>
								</ng-container> 
							</span>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.departureCity2}}, {{sector2list.value.departureCityCode2}}
						</td>
						<td *ngIf="manualEntryChecked" style="min-width: 150px;">
							<input tabIndex="{{i*11+7+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+7+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtAirlineDepartInfo2" (change)="sectorService.setNarration()"/>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.arrivalCity2}}, {{sector2list.value.arrivalCityCode2}}
						</td>
						<td *ngIf="manualEntryChecked"  style="min-width: 150px;">
							<input tabIndex="{{i*11+9+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+9+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtAirlineArrivalInfo2" />
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sector2list.value.txtBaggage2}}
						</td>
						<td *ngIf="manualEntryChecked">

							<input tabIndex="{{i*11+11+(isTenantIndian ? 18 : 20)}}" attr.tabIndex="{{i*11+11+(isTenantIndian ? 18 : 20)}}"
								oninput="this.value = this.value.toUpperCase()" class="traveller-input-field"
								type="text" formControlName="txtBaggage2" />
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</form>